module.exports = __webpack_public_path__ + "img/fig01.a2ed0959.jpg";